import {ThemeProvider} from "@zendeskgarden/react-theming";
import {ReactElement, useContext, useEffect, useMemo} from "react";
import {ViziblyTheme} from "../analyst/ViziblyZDGTheme";
import * as css from "./utm.module.scss";
import useAppStore from "../../hooks/useAppStore";
import "native-injects";
import {getBudgetYearForProperty, Property, useProperties} from "../../contexts/properties/PropertiesContext";
import UnitTypes from "./components/unit-types/UnitTypes";
import {useHistory, useRouteMatch} from "react-router-dom";
import {Dropdown, Field, Item, Menu, Select} from "@zendeskgarden/react-dropdowns";
import {InPlaceRentSetup} from "./components/in-place-rent/InPlaceRentSetup";
import {AuthContext} from "../../contexts/AuthContext";
import {RevenueModelType} from "../../__generated__/generated_types";
import {AffordableInPlaceRentSetup} from "./components/affordable-in-place-rent/AffordableInPlaceRentSetup";

function getLabel(page: string): string {
    if(page === "unit_types") {
        return "Unit Types";
    }
    if(page === "ipr") {
        return "In Place Rents Overrides";
    }
    return "";
}


export default function UnitTypeManagement(): ReactElement | null {
    const appStore = useAppStore();
    const auth = useContext(AuthContext);
    const {currentProperty} = useProperties();
    const routeMatch = useRouteMatch<{what: string;}>("/settings/unit-type-management/:what");
    const what = !routeMatch?.params.what ? "unit_types" : ["unit_types", "ipr"].includes(routeMatch?.params.what) ? routeMatch?.params.what : "unit_types";
    const history = useHistory();

    const budgetYear = getBudgetYearForProperty(currentProperty, auth.budgetYear);


    useEffect(
        () => {
            appStore.set({isLoading: false});
            return () => undefined;
        },
        []
    );

    const sectionSelector = useMemo(() => {
        return (
            <Dropdown
                selectedItem={what}
                onSelect={(v) => history.push(`/settings/unit-type-management/${v}`)}
            >
                <Field className={css.sectionDropdownField}>
                    <Select>
                        <h4>{getLabel(what)}</h4>
                    </Select>
                </Field>
                <Menu>
                    <Item key="unit_types" value="unit_types">
                        {getLabel("unit_types")}
                    </Item>
                    <Item key="ipr" value="ipr">
                        {getLabel("ipr")}
                    </Item>
                </Menu>
            </Dropdown>

        );
    }, [what]);

    if(!currentProperty) {
        return null;
    }

    function renderChosenComponent(property: Property, what: string | null | undefined): ReactElement {
        if(what === "ipr") {
            if(property.revenueModel === RevenueModelType.Affordable) {
                return <AffordableInPlaceRentSetup property={property} customLabelComponent={sectionSelector} budgetYear={budgetYear} />;
            }
            return <InPlaceRentSetup property={property} customLabelComponent={sectionSelector} budgetYear={budgetYear} />;
        }
        return <UnitTypes property={property} customLabelComponent={sectionSelector} budgetYear={budgetYear} />;
    }

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <div className={css.wrapper}>
                {renderChosenComponent(currentProperty, what)}
            </div>
        </ThemeProvider>
    );
}